module.exports = __webpack_public_path__ + "img/1531726771.b4aae8cf.jpg";